export default __webpack_public_path__ + "static/media/pantry1-afterH-1440w.4b9b473a.png";